import { CreditRolePermissions } from '../../permissions'

const CREDIT_ADMIN: CreditRolePermissions = {
  credit_audit_trails_view: true,
  credit_customers_view: true,
  credit_duns_and_bradstreet_edit: true,
  credit_index_scores_create: true,
  credit_index_scores_delete: true,
  credit_index_scores_update: true,
  credit_index_scores_view: true,
  google_financial_statements_create: true,
  google_financial_statements_delete: true,
  google_financial_statements_update: true,
  google_financial_statements_view: true,
  credit_invites_delete: true,
  credit_invites_send: true,
  credit_invites_view: true,
  credit_delegation_of_authority_view: true,
  credit_delegation_of_authority_edit: true,
  credit_limit_reviews_view: true,
  credit_blocked_orders_view: true,
  credit_initiatives_view: true,
  credit_operations_view: true,
  credit_multiplier_view: true,
  credit_multiplier_edit: true,
  credit_order_cutoff_view: true,
  credit_order_cutoff_edit: true,
  credit_province_aov_view: true,
  credit_province_aov_edit: true,
  credit_very_low_risk_customers_create: true,
  credit_very_low_risk_customers_delete: true,
  credit_very_low_risk_customers_view: true,
  credit_review_events_view: true,
  credit_roles_view: true,
  credit_sap_imports_create: true,
  credit_sap_imports_delete: true,
  credit_upload_allUploads_view: true,
  credit_upload_myUpload_view: true,
  credit_users_manageAccess: true,
  credit_users_view: true,
}

export default CREDIT_ADMIN
